import React from 'react';
import { useDesign } from '../../contexts/DesignContext';

const StaticPageLayout = ({ title, draftNotice, children }) => {
  const { designConfig } = useDesign();

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: designConfig.background_color || '#FFF8F5' }}
    >
      <section
        className="relative text-white py-16 md:py-20 overflow-hidden"
        style={{
          background: `linear-gradient(135deg, ${designConfig.primary_color || '#D4AF37'} 0%, ${designConfig.secondary_color || '#C9A9DD'} 50%, ${designConfig.accent_color || '#F4A5C7'} 100%)`
        }}
      >
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-light tracking-wide" style={{ fontFamily: 'serif' }}>
            {title}
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            {draftNotice && (
              <div className="mb-8 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                This page is a starting template. Items marked <strong>[TODO]</strong> need to be confirmed and filled in by the Viverra team before publishing.
              </div>
            )}
            <div
              className="prose max-w-none space-y-5 text-base leading-relaxed"
              style={{ color: designConfig.text_color || '#374151' }}
            >
              {children}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StaticPageLayout;
